require("./wdh-legacy/two-section-grid/js/base/component-two-section-grid.js");